import React from 'react';
//import CardProfile from '../../../components/Profile/Card/';
import ProgressReward from '../../components/Profile/ProgressReward/index';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { connect } from 'react-redux';
import './Progress.scss';

function Progress({ role, authClient }) {

  return (
    <>
          <div className="progress-content" style={{paddingTop:20}}>
            <div className="progress-content-awardsList">
              <p style={{ color: '#10587f', fontSize: 22, fontWeight: 'bold', marginBottom: 24 }}>Recompensas</p>
              <div>
                <ProgressReward
                  title="Apariencia"
                  description={role === 'lawFirm' ?
                    'Agrega el logo del despacho y selecciona una imagen de portada.' :
                    'Coloca una foto de perfil y selecciona una imagen de portada.'
                  }
                  tooltip={['Este logro lo obtienes al colocar tu ', <b>foto de perfil</b>, ' y seleccionar una ', <b>foto de portada</b>, '.']}
                  active={authClient && authClient.awardPerfil.look ? authClient.awardPerfil.look : false}
                />
                <ProgressReward
                  title={role === 'lawFirm' ? "Sobre tu despacho" : "Sobre ti"}
                  description={role === 'lawFirm' ? 
                    'Coloca el nombre del despacho y datos relevantes sobre él.' :
                    'Coloca tu nombre y datos relevantes sobre tu perfil profesional.'
                  }
                  tooltip={['Se obtiene al llenar todos los ', <b>campos que hablan sobre ti</b>, ' en el perfil.']}
                  active={authClient && authClient.awardPerfil.about ? authClient.awardPerfil.about : false}
                />
                {role === 'lawFirm' ?
                  <ProgressReward
                    title="Titular del despacho"
                    description="Agrega los datos de perfil del o los titulares del despacho."
                    tooltip={['Llena los ', <b>datos de perfil</b>, ' del o los titulares del despacho para ', <b>generar confianza</b>, '.']}
                    active={authClient && authClient.awardPerfil.holder ? authClient.awardPerfil.holder : false}
                  /> :
                  null
                }
                {role === 'lawFirm' ?
                  <ProgressReward
                    title="Equipo de trabajo del despacho"
                    description="Son los abogados o colegas que forman parte del equipo del despacho y que puedes agregar en la plataforma."
                    tooltip={['Obtén este logro al ', <b>agregar</b>, ' los perfiles de los ', <b>colaboradores</b>, ' del despacho.']}
                    active={authClient && authClient.awardPerfil.collaborators ? authClient.awardPerfil.collaborators : false}
                  /> :
                  null
                }
                <ProgressReward
                  title="Experiencia"
                  description={role === 'lawFirm' ?
                    'Es importante mencionar cuánto tiempo de experiencia tiene el despacho para brindar más confianza y seguridad a los clientes.' :
                    'Es importante mencionar cuánto tiempo tienes de experiencia en el mercado para brindar confianza y seguridad a los clientes.'
                  }
                  tooltip={['Consigue este trofeo al llenar el ', <b>sector</b>, ' con tu ', <b>experiencia en el campo legal</b>, '.']}
                  active={authClient && authClient.awardPerfil.experience ? authClient.awardPerfil.experience : false}
                />
                <ProgressReward
                  title={role === 'lawFirm' ? "Información" : "Contacto"}
                  description={role === 'lawFirm' ?
                    "Los datos de contacto que se agregaron para generar más clientes." :
                    "Son los datos que se mostrarán para que nuevos clientes se pongan en contacto contigo."
                  }
                  tooltip={['Llena todos los campos para tener ', <b>mayor visibilidad</b>, ' con ', <b>clientes potenciales</b>, '. ¡No olvides guardar los cambios!']}
                  active={authClient && authClient.awardPerfil.contact ? authClient.awardPerfil.contact : false}
                />
                <ProgressReward
                  title={role === 'lawFirm' ? "Sedes" : "Sede"}
                  description={role === 'lawFirm' ?
                    'Sedes con las que cuenta el despacho.' :
                    'Agrega la dirección de tu lugar de trabajo.'
                  }
                  tooltip={role === 'lawFirm' ?
                    ['Es importante ', <b>registrar tus sedes</b>, ' para ', <b>generar confianza</b>, ' con los clientes.'] :
                    ['Es importante ', <b>registrar una sede</b>, ' para ', <b>generar confianza</b>, ' con los clientes.']
                  }
                  active={authClient && authClient.awardPerfil.site ? authClient.awardPerfil.site : false}
                />
              </div>
            </div>
          </div>
          
          <hr/>

          <div className="progress-content">
            <div className="progress-content-awardsList">
            <p style={{ color: '#10587f', fontSize: 22, fontWeight: 'bold', marginBottom: 24 }}>Recompensas adicionales</p>
              <div>
                <ProgressReward
                  title="Costo de Servicios"
                  description={role === 'lawFirm' ?
                    'Mostrar tarifas y precios desde el primer contacto con clientes.' :
                    'Muestra tus tarifas y precios desde el primer contacto con los clientes.'
                  }
                  tooltip={role === 'lawFirm' ?
                    ['Hazle saber a tus posibles clientes el ', <b>rango de precios</b>, ' que podrían pagar por una asesoría con el despacho.'] :
                    ['Hazle saber a tus posibles clientes el ', <b>rango de precios</b>, ' que podrían pagar por una asesoría contigo.']
                  }
                  active={authClient && authClient.awardAditional.cost ? authClient.awardAditional.cost : false}
                />
                <ProgressReward
                  title="Fotografías"
                  description={role === 'lawFirm' ?
                    'Fotografías relacionadas con los servicios del despacho.' :
                    'Fotografías relacionadas con tus servicios.'
                  }
                  tooltip={role === 'lawFirm' ?
                    ['Sube ', <b>7 fotografías de tu despacho</b>, ', premios, conferencias, etc, y consigue ', <b>más visibilidad</b>, ' de clientes.'] :
                    ['Sube hasta ', <b>7 fotografías</b>, ', de premios, conferencias, instalaciones, servicios, etc, y consigue ', <b>más visualizaciones</b>, ' de tu perfil.']
                  }
                  active={authClient && authClient.awardAditional.pictures ? authClient.awardAditional.pictures : false}
                />
                <ProgressReward
                  title="Videos informativos"
                  description={role === 'lawFirm' ?
                    'Podrás linkear videos en el sitio los cuales recomendamos que sean en relación con la explicación de quiénes son y los servicios del despacho.' :
                    'Podrás linkear videos en el sitio, los cuales tendrán que se con relación a la explicación de tus servicios y trayectoria profesional.'
                  }
                  tooltip={['Sube hasta ', <b>7 videos sobre tus servicios</b>, ' y obtén más presencia con los clientes.']}
                  active={authClient && authClient.awardAditional.videos ? authClient.awardAditional.videos : false}
                />
                <ProgressReward
                  title="Compartir"
                  description={role === 'lawFirm' ?
                    'Comparte el perfil del despacho en redes sociales para que lo conozcan y opinen sobre sus servicios.' :
                    'Obtén este logro al compartir tu perfil de Contacta Abogado® en tus distintas redes sociales.'
                  }
                  tooltip={[<b>Comparte</b>, ' tu perfil ', <b>en redes sociales</b>, ' y desbloquea este logro.']}
                  active={authClient && authClient.awardAditional.shareProfile ? authClient.awardAditional.shareProfile : false}
                />
                <ProgressReward
                  title="Calificación mayor a 4 estrellas"
                  description='Si tienes una calificación mayor a 4 estrellas, tienes más posibilidades de aparecer en los principales listados de búsqueda y generar mayor confianza en los clientes.'
                  tooltip={['Brinda el mejor servicio a tus clientes y obtén ', <b>excelentes opiniones</b>, ' dentro de nuestra plataforma.']}
                  active={authClient && authClient.awardAditional.highQualification ? authClient.awardAditional.highQualification : false}
                />
              </div>
            </div>
          </div>
        
      
    </>
  );
}

const mapStateToProps = state => {
  return {
    role: state.authClient.role,
    authClient: state.authClient,
  }
}

export default connect(mapStateToProps)(Progress);
